import React from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  className?: string;
  styles?: any;
  value?: Option | null; // ✅ Allow controlled value
  onChange?: (option: Option | null) => void; // ✅ Bubble up selected value
}

const CommonSelect: React.FC<SelectProps> = ({
  options,
  className,
  styles,
  value,
  onChange,
}) => {
  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      styles={styles}
      options={options}
      value={value || null} // Show currently selected value
      onChange={onChange} // Send back selection to parent
      placeholder="Select"
      isClearable
    />
  );
};

export default CommonSelect;
